/**
 * 工具类
 */
import CryptoJS from 'crypto-js';
export default {
  //加密
  //解密
  decrypt(word, keyStr) {
    keyStr = keyStr ? keyStr : 'abcdefgabcdefg12';
    var key = CryptoJS.enc.Utf8.parse(keyStr);
    var decrypt = CryptoJS.AES.decrypt(word, key, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7,
    });
    return CryptoJS.enc.Utf8.stringify(decrypt).toString();
  },
  // aes加密
  encrypt(context) {
    let key = CryptoJS.enc.Utf8.parse('A-16-Byte-keyVal');
    let iv = CryptoJS.enc.Utf8.parse('A-16-Byte-String');
    let encrypted = '';
    if (typeof context == 'object') {
      context = JSON.stringify(context);
    }
    let srcs = CryptoJS.enc.Utf8.parse(context);
    encrypted = CryptoJS.AES.encrypt(srcs, key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });
    return encrypted.toString();
  },
};
